import { MapPin, Phone, Mail, Linkedin, Twitter, Facebook } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: ["Études de marché", "Analyses financières", "Conseil stratégique", "Études sectorielles", "Accompagnement PME", "Développement digital"],
    company: ["À propos", "Notre équipe", "Nos valeurs", "Carrières", "Actualités", "Contact"],
    legal: ["Mentions légales", "Politique de confidentialité", "Conditions d'utilisation", "RGPD"],
  };

  return (
    <footer className="bg-[hsl(var(--brand-navy))] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold tracking-tight">A&DW CONSULTING</h3>
              <p className="text-white/50 text-xs tracking-widest uppercase mt-1">Études & Conseil Économique</p>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Votre partenaire de confiance pour toutes vos analyses financières et études économiques depuis 2019.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-white/70">
                <MapPin className="h-4 w-4 text-[hsl(var(--brand-red))]" />
                <span>21 Avenue Jean Jaurès, Dakar</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-white/70">
                <Phone className="h-4 w-4 text-[hsl(var(--brand-red))]" />
                <span>+221 33 821 71 27</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-white/70">
                <Mail className="h-4 w-4 text-[hsl(var(--brand-red))]" />
                <span>contact@adwconseils.com</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-white/90">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((s, i) => (
                <li key={i}><a href="#services" className="text-white/60 hover:text-[hsl(var(--brand-red))] transition-colors text-sm">{s}</a></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-white/90">Entreprise</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((c, i) => (
                <li key={i}><a href="#" className="text-white/60 hover:text-[hsl(var(--brand-red))] transition-colors text-sm">{c}</a></li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-widest mb-6 text-white/90">Suivez-nous</h4>
            <p className="text-white/60 text-sm mb-6">Restez informé de nos analyses économiques et actualités.</p>
            <div className="flex gap-3">
              {[Linkedin, Twitter, Facebook].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-xl bg-white/10 hover:bg-[hsl(var(--brand-red))] flex items-center justify-center transition-all duration-300">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">© {currentYear} A&DW Consulting. Tous droits réservés.</p>
          <div className="flex gap-6 text-xs">
            {footerLinks.legal.map((l, i) => (
              <a key={i} href="#" className="text-white/50 hover:text-white/80 transition-colors">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
